import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { axiosInstance } from "../utils/axiosInstance";

const Order = () => {
  const DateFormatter = ({ createdAt }) => {
    const date = new Date(createdAt);

    const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;

    return <p>{formattedDate}</p>;
  };

  const [allOrder, setAllOrder] = useState([]);
  const getAllOrder = async () => {
    try {
      await axiosInstance.get("user/order").then((response) => {
        if (response?.data?.status === true) {
          setAllOrder(response?.data?.orders);
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    getAllOrder();
  }, []);
  return (
    <div className="dashboard_content">
      <div className="dashboard_body">
        <h3>order list</h3>
        <div className="dashboard_order">
          <div className="table-responsive">
            <table className="table">
              <tbody>
                <tr className="t_header">
                  <th>Tracking Id</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Amount</th>
                  <th>Action</th>
                </tr>
                {allOrder?.length > 0 ? (
                  allOrder.map((e, i) => (
                    <tr key={i}>
                      <td>
                        <h5>{e?.tracking_id}</h5>
                      </td>
                      <td>
                        <DateFormatter createdAt={e?.created_at} />
                      </td>
                      <td>
                        <span
                          className={
                            e?.status === "process"
                              ? "active"
                              : e?.status === "pending"
                              ? "active"
                              : e?.status === "cancelled"
                              ? "cancel"
                              : "complete"
                          }
                        >
                          {e?.status}
                        </span>
                      </td>
                      <td>
                        <h5>${e?.total_price}</h5>
                      </td>
                      <td>
                        <Link to="/trackorder" state={e?.tracking_id}>
                          View Details
                        </Link>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5">
                      <h5 style={{ textAlign: "center", padding: "20px" }}>
                        No Order Found...!
                      </h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
